module.exports = __webpack_public_path__ + "static/media/menu22.89bb76a5.jpg";